import { render, staticRenderFns } from "./req-pay.vue?vue&type=template&id=264eff14&scoped=true"
import script from "./req-pay.vue?vue&type=script&lang=js"
export * from "./req-pay.vue?vue&type=script&lang=js"
import style0 from "./req-pay.vue?vue&type=style&index=0&id=264eff14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264eff14",
  null
  
)

export default component.exports